const initialState = {
    pollingRelatedCount: 0
}
export const PollingCounterReducer = (state = initialState, action) => {
   switch (action.type) {
       case 'INCREMENT_POLLING_COUNT':
           return {
               ...state,
               pollingRelatedCount: state.pollingRelatedCount + 1,
           };
       case 'DECREMENT_POLLING_COUNT':
           return {
               ...state,
               pollingRelatedCount: Math.max(0, state.pollingRelatedCount - 1),
           };
       case 'RESET_POLLING_COUNT':
           return {
               ...state,
               pollingRelatedCount: 0,
           };
       default:
           return state;
   }
};